"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const selectors_1 = require("@zedoc/selectors");
/**
 * @template T
 * @param {T} value
 * @returns {T}
 */
const useReconcile = (value) => {
    const ref = /** @type {typeof useRef<T | null>} */ (react_1.useRef)(null);
    ref.current = /** @type {T} */ ((0, selectors_1.reconcile)(ref.current, value, {}));
    return ref.current;
};
exports.default = useReconcile;
//# sourceMappingURL=index.js.map